
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, X, LogOut } from "lucide-react";

export default function Header({ onLogout }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [username, setUsername] = useState("");

  useEffect(() => {
    const storedUser = localStorage.getItem("username") || "Guest";
    setUsername(storedUser);
  }, []);

  const menuItems = [
    
    { name: "Verify Customer", path: "/verifycustomers", color: "bg-orange-500" },
    { name: "Items", path: "/items", color: "bg-orange-500" },
    { name: "Order Details", path: "/orderdetails", color: "bg-orange-500" },
    { name: "Order Summary", path: "/ordersummary", color: "bg-orange-500" },
    { name: "Payment Approval", path: "/paymentapproval", color: "bg-orange-500" },
    { name: "Customer Master", path: "/CustomerExplr", color: "bg-orange-500" },
    { name: "Order Form", path: "/orderformexplorer", color: "bg-orange-500" },
    { name: "Delivery Allotment", path: "/deliveryallotment", color: "bg-orange-500" },
    { name: "Delivery Update", path: "/deliveryupdate", color: "bg-orange-500" },
    { name: "Order Process", path: "/orderprocess", color: "bg-orange-500" },
    { name: "Receipt Upload", path: "/receiptupload", color: "bg-orange-500" },
    { name: "Order and Payment", path: "/orderandpayment", color: "bg-orange-500" },
    { name: "Ratings and FeedBack", path: "/orderRatings", color: "bg-orange-500" },
    
   

  ];

  return (
    <>
      {/* Desktop Sidebar */}
      <aside className="fixed top-0 left-0 z-20 hidden h-screen p-6 space-y-4 bg-white shadow-lg md:flex md:flex-col w-60">
        <h1 className="mb-6 text-2xl font-bold tracking-wide text-gray-900">  Annam Foods</h1>
        {menuItems.map((item, idx) => (
          <Link
            key={idx}
            to={item.path}
            className={`px-4 py-1 text-sm font-semibold text-white rounded-lg ${item.color} hover:brightness-90 transition-all shadow-sm`}
          >
            {item.name}
          </Link>
        ))}
        <button
          onClick={onLogout}
          className="flex items-center justify-center gap-1 px-1 py-2 mt-auto text-sm font-semibold text-white transition-all bg-red-500 rounded-lg shadow-sm hover:brightness-90"
        >
          <LogOut size={16} /> Logout
        </button>
      </aside>

      {/* Mobile Topbar */}
      <header className="sticky top-0 z-30 bg-white shadow-md md:hidden">
        <div className="flex items-center justify-between max-w-full px-4 py-3 mx-auto">
          <button className="text-gray-700" onClick={() => setMenuOpen(true)}>
            <Menu size={22} />
          </button>
          <h1 className="text-2xl font-bold tracking-wide text-gray-900">Annam Foods</h1>
        </div>

        {/* Mobile Sidebar */}
        <div
          className={`fixed inset-0 z-40 md:hidden transition-transform duration-300 ${menuOpen ? "translate-x-0" : "-translate-x-full"
            }`}
        >
          {/* Overlay background */}
          <div
            className={`absolute inset-0 bg-black bg-opacity-30 backdrop-blur-sm ${menuOpen ? "block" : "hidden"}`}
            onClick={() => setMenuOpen(false)}
          ></div>

          {/* Sidebar panel */}
          <div className="relative z-50 flex flex-col p-6 space-y-4 bg-gray-200 shadow-xl w-60">
            <button className="self-end text-gray-700" onClick={() => setMenuOpen(false)}>
              <X size={24} />
            </button>
            {menuItems.map((item, idx) => (
              <Link
                key={idx}
                to={item.path}
                className={`w-full px-3 py-2 text-center text-white font-semibold rounded-lg ${item.color} hover:brightness-90 transition-all shadow-sm`}
                onClick={() => setMenuOpen(false)}
              >
                {item.name}
              </Link>
            ))}
            <button
              onClick={() => {
                onLogout();
                setMenuOpen(false);
              }}
              className="flex items-center justify-center w-full gap-2 px-4 py-2 mt-auto text-sm font-semibold text-white transition-all bg-red-500 rounded-lg shadow-sm hover:brightness-90"
            >
              <LogOut size={16} /> Logout
            </button>
          </div>
        </div>
      </header>

      {/* Spacer for desktop content */}
      <div className="md:ml-64"></div>
    </>
  );
}


// import React from "react";
// import { Link } from "react-router-dom";

// export default function Header({ onLogout }) {
//   return (
//     <header className="sticky top-0 z-10 bg-white shadow-sm">
//       <div className="flex items-center justify-between px-6 py-4 mx-auto max-w-7xl">
//         <h1 className="text-2xl font-bold text-orange-600">Admin Dashboard</h1>

//         <div className="flex items-center space-x-4">
//           <Link
//             to="/items"
//             className="px-3 py-1 text-white transition bg-orange-500 rounded-lg hover:bg-orange-600"
//           >
//             Items
//           </Link>

//           <Link
//             to="/orderdetails"
//             className="px-3 py-1 text-white transition bg-orange-500 rounded-lg hover:bg-orange-600"
//           >
//             Order Details
//           </Link>

//           <button
//             onClick={onLogout}
//             className="px-3 py-1 text-white transition bg-red-500 rounded-lg hover:bg-red-600"
//           >
//             Logout
//           </button>
//         </div>
//       </div>
//     </header>
//   );
// }
